import React from 'react';
import classes from './DisabledIcon.module.scss';

export const DisabledIcon = ({ iconComponent }: { iconComponent: JSX.Element }) => {
    return <div className={classes.iconComponentContainer}>{iconComponent}</div>;
};
